export default __webpack_public_path__ + "static/media/IntroductionImage.eea68ee2.png";